import { Guide } from '../../lib/types/models/guide/guide'
import { GuideInput } from '../../lib/types/models/guide/guide-input'

export const mapGuideDataDefaultValues = (guide: Guide): GuideInput => ({
  userType: guide.userType,
  name: guide.name,
  description: guide.description || '',
  pdf: guide.pdf,
  picto: guide.picto,
  countryIds: guide.countries?.map((country) => country.id) || [],
  formulaIds: guide.formulas?.map((formula) => formula.id) || [],
  accomodationTypes: guide.accomodationTypes || [],
  staffPositions: guide.staffPositions || [],
  qualifications: guide.qualifications || [],
  optionIds: guide.options?.map((option) => option.id) || []
})
